<template>
  <div>
    <label class="form__label primary--text" :for="idElement">
      {{ labelText }}
      <v-tooltip
        bottom
        v-if="iconInformation"
        content-class="tooltip-label-form"
      >
        <template v-slot:activator="{ on }">
          <v-icon color="secondary" size="10" v-on="on">
            fa-info-circle
          </v-icon>
        </template>
        <v-row>
          <v-col cols="12" class="px-4 py-3">
            <p class="white--text tooltip-label-text mb-0">
              {{ textInformation }}
            </p>
          </v-col>
        </v-row>
      </v-tooltip>
    </label>
    <money
      ref="selectInput"
      v-on="$listeners"
      v-bind="[errorMessages.length == 0 ? defaultConfigs : validateConfigs]"
      :id="idElement"
    />
    <div v-if="errorMessages.length > 0" class="v-text-field__details my-2">
      <div class="v-messages theme--light error--text" role="alert">
        <div class="v-messages__wrapper">
          <div
            v-for="(message, index) in errorMessages"
            :key="`error-message-${index}`"
            class="v-messages__message ml-3"
          >
            {{ message }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    defaultConfigs() {
      return Object.assign(
        {
          class: "mt-2 input-money",
        },
        {
          ...this.$attrs,
          ...this.$props,
          ...this.money,
        }
      );
    },
    validateConfigs() {
      return Object.assign(
        {
          class: "mt-2 input-money-validate",
        },
        {
          ...this.$attrs,
          ...this.$props,
          ...this.money,
        }
      );
    },
  },
  props: {
    idElement: {
      type: String,
    },
    labelText: {
      type: String,
    },
    iconInformation: {
      type: Boolean,
      default: false,
    },
    textInformation: {
      type: String,
    },
    errorMessages: {
      type: Array,
      default: function () {
        return [];
      },
    },
    money: {
      type: Object,
      default: function () {
        return {
          decimal: ",",
          thousands: ".",
          prefix: "R$ ",
          suffix: "",
          precision: 2,
          masked: false /* doesn't work with directive */,
        };
      },
    },
  },
};
</script>
<style lang="sass">
.input-money
  width: 100% !important
  border: 1px solid #D5D5E0
  border-radius: 2px
  background-color: white
  height: 40px
  padding: 12px 15px
.input-money-validate
  width: 100% !important
  border: 2px solid #ef5350
  border-radius: 2px
  background-color: white
  height: 40px
  padding: 12px 15px
.input-money:disabled
  background-color: #F0F0F7
  color: rgba(0,0,0,.38)
</style>
